/**
 * User
 */
export const SAVE_USER = 'SAVE_USER'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'

/**
 * Event Details
 */
export const EVENT_DETAILS_FETCH_START = 'EVENT_DETAILS_FETCH_START'
export const EVENT_DETAILS_FETCH_FAIL = 'EVENT_DETAILS_FETCH_FAIL'
export const EVENT_DETAILS_FETCH_SUCCESS = 'EVENT_DETAILS_FETCH_SUCCESS'

/**
 * Event Assets
 */
export const EVENT_ASSETS_FETCH_START = 'EVENT_ASSETS_FETCH_START'
export const EVENT_ASSETS_FETCH_FAIL = 'EVENT_ASSETS_FETCH_FAIL'
export const EVENT_ASSETS_FETCH_SUCCESS = 'EVENT_ASSETS_FETCH_SUCCESS'

/**
 * Queues
 */
export const CLEAR_QUEUE = 'CLEAR_QUEUE'
export const PUSH_POST_AUTH_QUEUE_ITEM = 'PUSH_POST_AUTH_QUEUE_ITEM'
export const PUSH_ONBOARDING_QUEUE_ITEM = 'PUSH_ONBOARDING_QUEUE_ITEM'

/**
 * Saved Assets
 */
export const UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER =
  'UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER'
